import { useSelector, useDispatch } from "react-redux";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import {
  setThemeMode,
  setPrimaryColor,
  setSecondaryColor,
  setCustomColor,
  setCustomColors,
  resetTheme,
  toggleThemeMode,
} from "../state/slices/theme";
import { getEffectiveThemeMode } from "../state/slices/theme";

/**
 * Custom hook for accessing and managing theme
 * Combines MUI theme with Redux theme state
 * 
 * @returns {Object} Theme object with MUI theme and theme actions
 */
export const useAppTheme = () => {
  const muiTheme = useMuiTheme();
  const themeState = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  const effectiveMode = getEffectiveThemeMode(themeState.mode);
  
  return {
    // MUI theme object
    theme: muiTheme,
    // Theme state from Redux
    themeState,
    mode: themeState.mode,
    effectiveMode,
    // Actions
    setMode: (mode) => dispatch(setThemeMode(mode)),
    toggleMode: () => dispatch(toggleThemeMode()),
    setPrimary: (color) => dispatch(setPrimaryColor(color)),
    setSecondary: (color) => dispatch(setSecondaryColor(color)),
    setCustom: (key, value) => dispatch(setCustomColor({ key, value })),
    setCustoms: (colors) => dispatch(setCustomColors(colors)),
    reset: () => dispatch(resetTheme()),
    isDark: effectiveMode === "dark",
    isLight: effectiveMode === "light",
    isSystem: themeState.mode === "system",
  };
};

export default useAppTheme;


